import PageTitle from "../Common/PageTitle"
import ToolBar from "../Common/Toolbar"
import { FC, Fragment, useEffect, useState } from "react"
import columns from "./columns"
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import MenuListPop from "../Common/menu"
import { DeleteOutlineOutlined, EditOutlined, RemoveRedEyeOutlined } from "@mui/icons-material"
import { UtilityProps } from "../../types/utilities"
import { Apis, numberWithCommas } from "../../helpers"
import { PropertyProps } from "../../types/properties"
import NoData from "../Common/NoData"
import { useNavigate } from "react-router-dom"
import { Connect, mapStateToProps } from "../../Redux"
import DeleteModal from '../Common/deletePrompt'


interface StateProps {
    data: UtilityProps[]
    loading: boolean
    showDeleteModal: null | UtilityProps
    refreshing: boolean
}
interface Props {
    tablesColumnsFilters?: {
        utilities: string[]
    }
    selectedProperty?: PropertyProps
}
const Utilities: FC<Props> = ({
    selectedProperty,
    tablesColumnsFilters
}) => {
    const [state, setState] = useState<StateProps>({
        data: [],
        showDeleteModal: null,
        loading: true,
        refreshing: false
    })
    const navigate = useNavigate()

    const menuList = [
        { label: 'Edit', icon: <EditOutlined /> },
        { label: 'View Payments', icon: <RemoveRedEyeOutlined /> },
        { label: 'Update Records', icon: <RemoveRedEyeOutlined /> },
        { label: 'Delete', icon: <DeleteOutlineOutlined /> }
    ]
    const { data, loading, showDeleteModal, refreshing } = state
    const DisplayColums = columns.filter(col => tablesColumnsFilters?.utilities.includes(col.name))


    const getPropertyUtilities = ({
        refreshing
    }: any) => {
        if (refreshing)
            setState({ ...state, refreshing: true })
        Apis({
            module: 'Properties',
            action: 'getPropertyUtilities',
            _id: selectedProperty?._id
        }).then((data: any) => {
            setState({ ...state, data, loading: false })
        }).catch(() => {
            setState({
                ...state,
                loading: false
            })
        })
    }
    useEffect(() => {
        getPropertyUtilities({})
        // eslint-disable-next-line 
    }, [])
    return (
        <Box sx={{ height: '100%', pr: 5 }}>
            <PageTitle title={"Utilities & Amenities"} />
            {!loading && data.length ?
                <ToolBar
                    columnsFilter={'utilities'}
                    columns={columns}
                    addTitle={'Add Utility'}
                    addPage={'/new_utility'}
                    refreshing={refreshing}
                    onRefresh={() => getPropertyUtilities({ refreshing: true })}
                />
                : null}
            {
                !data?.length || loading ?
                    <NoData
                        message={`You don't have any utility.`}
                        createMessage={`Add Utility`}
                        onCreate={() => navigate('/new_utility')}
                        loading={loading}
                    /> :
                    <Paper sx={{ width: '100%' }}>
                        <TableContainer sx={{ maxHeight: 440 }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {
                                            DisplayColums.map(({ label }) => (
                                                <TableCell sx={{ fontWeight: 'bold' }} key={label} /*align={column.align}*/>
                                                    {label}
                                                </TableCell>
                                            ))
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        data.map((datam, i) => {
                                            return (
                                                <TableRow hover role="checkbox" tabIndex={-1} key={datam.name}>
                                                    {
                                                        DisplayColums.map(({ label, name, isNumber }, x) => {
                                                            let value = (name === 'toBePaidWithRent' ? datam.toBePaidWithRent ? 'Yes' : 'No' : (datam as any)[name]) || 'None'
                                                            value = isNumber ? numberWithCommas(value) : value
                                                            return (
                                                                <TableCell key={label + '' + datam.name} /*align={column.align}*/>
                                                                    {
                                                                        name === 'action' ?
                                                                            <MenuListPop
                                                                                menuList={menuList}
                                                                                onSelect={option => {
                                                                                    if (option === 'Edit')
                                                                                        navigate('/new_utility', { state: { record: datam } })
                                                                                    else if (option === 'Delete')
                                                                                        setState({
                                                                                            ...state,
                                                                                            showDeleteModal: datam
                                                                                        })
                                                                                }} /> :
                                                                            value
                                                                    }
                                                                </TableCell>
                                                            )
                                                        })
                                                    }
                                                </TableRow>
                                            )
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
            }
            {
                showDeleteModal ?
                    <DeleteModal
                        item={showDeleteModal}
                        close={() => setState({ ...state, showDeleteModal: null })}
                        onDelete={() => {
                            const itemIndex = data?.findIndex(q => q._id === showDeleteModal?._id) as number
                            const Items = [...data as UtilityProps[]]
                            Items?.splice(itemIndex, 1)
                            setState({
                                ...state,
                                showDeleteModal: null,
                                data: Items
                            })

                        }}
                        deleteField={'_id'}
                        page='Utility'
                        module={'Properties'}
                        itemName={showDeleteModal.name}
                        utilityId={showDeleteModal._id}
                    /> :
                    <Fragment />

            }
        </Box>
    )
}

export default Connect(mapStateToProps)(Utilities)